import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

export const useConfirmationBookingInfo = () => {
  const { firstname, lastname, email, selectedSku, location, utcStart } = usePrenuvoStore(
    useShallow((state) => ({
      firstname: state.user.scheduledMember?.firstname,
      lastname: state.user.scheduledMember?.lastname,
      email: state.user.scheduledMember?.email,
      selectedSku: state.scan.sku,
      location: state.scan.location,
      utcStart: state.scan.slot?.utcStart,
    })),
  );

  return { firstname, lastname, email, selectedSku, location, utcStart };
};
